// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Atom_Icon_Ds = require("./Atom_Icon_Ds.bs.js");
var Atom_Icon_Css = require("./Atom_Icon_Css.bs.js");
var Atom_Icon_Path = require("./Atom_Icon_Path.bs.js");

function Atom_Icon(Props) {
  var icon = Props.icon;
  var size = Props.size;
  var title = Props.title;
  var dsIcon = Atom_Icon_Ds.makeIcon(icon);
  var match = Atom_Icon_Ds.view(dsIcon);
  var match$1 = Atom_Icon_Css.toCss(dsIcon, size);
  var __x = Belt_Array.map(match$1.svg, (function (rule) {
          var __x = [rule];
          return CssJs.style(__x);
        }));
  var svgClassName = CssJs.merge(__x);
  return React.createElement("svg", {
              "aria-hidden": true,
              className: svgClassName,
              focusable: "false",
              viewBox: match.viewBox,
              xmlns: "http://www.w3.org/2000/svg"
            }, title !== undefined ? React.createElement("title", undefined, title) : null, Atom_Icon_Path.getPath(icon));
}

var make = Atom_Icon;

exports.make = make;
/* CssJs Not a pure module */
